import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LawFirm } from '@models/lawFirms';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { GlobalDataManagementRequestDispatch } from 'src/app/global-data-management/state/global-data-management/global-data-management.request.dispatch';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-law-firm-side-form',
	templateUrl: './law-firms-edit-side-form.component.html',
	standalone: false,
})
export class EditLawFirmSideFormComponent {
	@Input() name;
	public isClient;
	public lawFirm: LawFirm;
	@SelectSnapshot(SelectedMatter.id) saleId;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private globalStoreDispatch: GlobalDataManagementRequestDispatch,
		private matterDispatch: MatterDispatch,
	) {
		const data = this.router.getCurrentNavigation()?.extras?.state;

		if (data) {
			this.lawFirm = data.lawFirm;
		} else {
			this.navigationService.goBack(this.route);
		}
	}

	onSubmit(event: LawFirm) {
		if (event) {
			this.matterDispatch.CreateLawFirm(this.saleId, event);
			this.globalStoreDispatch.RequestLawFirmChange(event);
		}

		this.navigationService.goBack(this.route);
	}

	onCancel() {
		this.navigationService.goBack(this.route);
	}
}
